module.exports = __webpack_public_path__ + "static/media/failure_payment_1.6edbe267.png";